import { dataHooks } from '../../../../../libs/dataHooks';

export const featuresFilterItemDataHooks = dataHooks<{
  item: { active: boolean };
  title: {};
  description: {};
}>('features-filter-item');
